export default {"src":"/_next/static/media/form-editor-custom-css.1ef54fcf.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};